import React, { useMemo, useEffect } from 'react';
import { IItemForGetShortInfo, IGetCategoriesByCustomerShort, IGetCategoriesShortResponse } from 'types';
import { Rule } from 'antd/lib/form';
import { useTranslation } from 'react-i18next';
import { useFetchData } from 'hooks/useFetchData';
import { getCategoriesByCustomerShortInfo } from 'backend/categories';
import FormSelect from 'components/Select/FormSelect';

interface IProps {
	setFetchedCategories: (value: IItemForGetShortInfo[]) => void;
	setIDCategory: (value: Nullable<string>) => void;
	customerId: Nullable<string>;
}

export const CategorySelect: React.FC<IProps> = React.memo(({ setFetchedCategories, setIDCategory, customerId }) => {
	const { response, loading, responseError, refetch } = useFetchData<
		IGetCategoriesShortResponse,
		IGetCategoriesByCustomerShort
	>(customerId ? getCategoriesByCustomerShortInfo : null, { customerId: customerId || '' });
	const { t } = useTranslation('error');
	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('selectCategory') }], [t]);

	useEffect(() => {
		refetch();
	}, [customerId]);

	useEffect(() => {
		if (response) {
			setFetchedCategories(response.data.categories);
		}
	}, [response]);

	return (
		<FormSelect
			name="IDSelectedCategory"
			label="categoryLabel"
			options={response?.data.categories}
			fetchError={responseError}
			loading={loading}
			disabled={!customerId || loading}
			validationRules={validationRules}
			onRefetch={refetch}
			onChange={setIDCategory}
		/>
	);
});
